import { render, staticRenderFns } from "./sharePoster.vue?vue&type=template&id=248dedbe&scoped=true&"
import script from "./sharePoster.vue?vue&type=script&lang=js&"
export * from "./sharePoster.vue?vue&type=script&lang=js&"
import style0 from "./sharePoster.vue?vue&type=style&index=0&lang=less&"
import style1 from "./sharePoster.vue?vue&type=style&index=1&id=248dedbe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248dedbe",
  null
  
)

export default component.exports